import React, { useState } from 'react';
import styled from 'styled-components';
import { VenueFilterData } from '../../../shared/dto/EntityRepository';

interface FilterStationVenueDistrictProps {
  currentFilter: VenueFilterData;
  setCurrentFilter: (filter: VenueFilterData) => void;
}

const parseDistricts = (raw: string): string[] =>
  raw
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);

const FilterStationVenueDistrict: React.FC<FilterStationVenueDistrictProps> = ({
  currentFilter,
  setCurrentFilter,
}) => {
  const [text, setText] = useState(currentFilter.districts.join(', '));

  return (
    <DistrictFilterComp>
      <DistrictSubTitle>District</DistrictSubTitle>
      <DistrictInput
        value={text}
        placeholder="종로구, 강남구"
        onChange={(e) => {
          const next = e.target.value;
          setText(next);
          setCurrentFilter({
            ...currentFilter,
            districts: parseDistricts(next),
          });
        }}
      />
    </DistrictFilterComp>
  );
};

export default FilterStationVenueDistrict;

const DistrictSubTitle = styled.div`
  margin-bottom: 1.2vh;
  ${({ theme }) => theme.typography.Body_03_1};
`;

const DistrictFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`;

const DistrictInput = styled.input`
  width: 100%;
  padding: 4px 0;
  border: none;
  border-bottom: 1px dotted ${({ theme }) => theme.colors.color_Gray_04};
  background: transparent;
  outline: none;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};

  &::placeholder {
    color: ${({ theme }) => theme.colors.color_Gray_05};
  }
`;
